module.exports = __webpack_public_path__ + "static/media/developed-by-certi.2dbff314.png";